/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/sesion';


// ---------------- Saga's response ----------------
function fetchSesionSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchSesionError(state) {
  state.response = [];
  state.errorFetchConfirmar = true;
}


const fetchSesion = createAction('fetchSesion');

// ------------- connection ------------- //

const sesionReducer = createSlice({
  name: 'Sesion',
  initialState,
  reducers: {
    fetchSesionSuccess,
    fetchSesionError,
  },
});

export const sesionAction = {
  ...sesionReducer.actions,
  fetchSesion,
};

export default sesionReducer.reducer;